<template lang="pug">
.media-filter
  .filter-group
    label Tags
    select(v-model="selectedTags", multiple)
      option(v-for="tag in tags", :key="tag.id", :value="tag.id") {{ tag.name }}

  .filter-group
    label Medientyp
    select(v-model="type")
      option(value="") Alle
      option(value="photo") Fotos
      option(value="video") Videos

  .filter-group
    label
      input(type="checkbox", v-model="useGPS") 
      div Mit GPS

  .filter-group
    label Datum von
    input(type="date", v-model="dateFrom")

  .filter-group
    label Datum bis
    input(type="date", v-model="dateTo")

  .filter-group
    label Kartenbereich
    MediaMapFilter(@update-map-bounds="handleMapBoundsUpdate")

  Button3d
    icon(name="play", @click="update")
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import MediaMapFilter from "@/components/MediaMapFilter.vue";
import Icon from "@/components/Icon.vue";
import Button3d from "./Button3d.vue";

export default {
  name: "MediaFilter",
  components: { MediaMapFilter, Icon, Button3d },
  data() {
    return {
      selectedTags: [],
      type: "photo",
      dateFrom: "",
      dateTo: "",
      useGPS: false,
      mapCenter: { lat: 48.1351, lng: 11.582 }, // München als Beispiel
      mapBounds: {
        north: 48.3,
        south: 48.0,
        east: 11.7,
        west: 11.4,
      },
    };
  },
  computed: {
    ...mapGetters({
      tags: "media/tags",
    }),
  },
  methods: {
    ...mapActions({
      getTags: "media/tags",
      updateFilter: "media/updateFilter",
    }),
    handleMapBoundsUpdate(mapBounds) {
      // Wenn die Kartengrenzen geändert werden, setze sie hier
      this.mapBounds = mapBounds;
    },
    update() {
      const filter = {
        isAdmin: false,
        userAccessLevel: 2,
        tags: this.selectedTags,
        type: this.type,
        dateFrom: this.dateFrom || null,
        dateTo: this.dateTo || null,
        useGPS: this.useGPS,
        bounds: this.mapBounds
      };
      console.log("update filter:", filter);
      this.updateFilter(filter);
      this.$emit('runFilter')
    },
  },
  mounted() {
    this.getTags();
    this.update();
  },
};
</script>

<style lang="less" scoped>
.media-filter {
  font-size: 3vw;
  color: black;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  .filter-group {
    flex: 1 1 200px;
    display: flex;
    flex-direction: column;
    label {
      font-weight: bold;
      margin-bottom: 0.25rem;
    }
    select,
    input {
      padding: 0.25rem;
      font-size: 1rem;
    }
  }
}
</style>
